export default __webpack_public_path__ + "static/email-templates-multiple-recipients-cc-bcc-840b785a735242e972e20e6b0bf89ec4.mp4";